import React from 'react';
import { Container, Typography, Box, Paper, Button } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { useNavigate } from 'react-router-dom';

const AccessDenied = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md">
      <Box sx={{ my: 4, textAlign: 'center' }}>
        <Paper 
          elevation={3} 
          sx={{ 
            p: 4, 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            backgroundColor: '#f8f8f8'
          }}
        >
          <LockIcon sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
          
          <Typography variant="h4" component="h1" gutterBottom>
            Accès refusé
          </Typography>
          
          <Typography variant="body1" color="text.secondary" paragraph>
            Vous n'avez pas les droits d'administration nécessaires pour accéder à cette page.
            Veuillez contacter un administrateur si vous pensez que vous devriez avoir accès.
          </Typography>
          
          <Button 
            variant="contained" 
            color="primary" 
            onClick={() => navigate('/')}
            sx={{ mt: 2 }}
          >
            Retour à l'accueil
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default AccessDenied; 